// extracted by mini-css-extract-plugin
module.exports = {"checkmarkWrap":"AdditionalFeatures_checkmarkWrap__184vY"};